import React from 'react';

const TerritoriesPage = () => {
  return (
    <div className="container mx-auto px-4 py-8">
      <div className="flex justify-between items-center mb-6">
        <h1 className="text-3xl font-bold text-jims-cyan-dark">Territories</h1>
      </div>
      <div className="bg-white p-6 rounded-lg shadow-md">
        <p>Territories management functionality will be implemented here.</p>
        {/* Add list, add button, etc. later */}
      </div>
    </div>
  );
};

export default TerritoriesPage;
